import React, { useState, useRef } from 'react'
import { localisationMaster } from 'Localisation/Localisation'
import { superAxiosRequest } from 'axiosApi'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import Stores from 'Stores'
import './style.scss'
import Button from 'components/CRM/UI/components/Button/Button'

const PTLogo = ({ file, setFile }) => {
  const [loading, setLoading] = useState(false)
  const inputFile = useRef(null)

  const sendFile = (data) => {
    const formData = new FormData()
    formData.append('file', data)
    setLoading(true)
    superAxiosRequest(
      {
        method: 'post',
        link: 'files/image_upload',
      },
      formData,
      'media',
    ).then((res) => {
      setFile(res.data.file)
      setLoading(false)
    })
  }
  return (
    <div className='placementTestLogoBox'>
      <div className='placementTestLogoBox__fileUpload'>
        <div className='placementTestLogoBox__logo'>
          {loading ? (
            <Loader />
          ) : file ? (
            <img src={Stores.baseLink() + file} alt='file/image' />
          ) : (
            <>
              <p className='placementTestLogoBox__text'>
                <span>Supported formats:</span> JPG, GIF, PNG
              </p>
              <p className='placementTestLogoBox__text'>
                <span>Maximum file size:</span> 2MB
              </p>
            </>
          )}
        </div>
        <input
          style={{ display: 'none' }}
          type='file'
          ref={inputFile}
          onChange={(e) => sendFile(e.target.files[0])}
          accept='image/*'
        />
        <Button
          onClick={() => inputFile.current.click()}
          isDisabled={loading}
          width={'160px'}
          text={localisationMaster(
            loading
              ? 'loading'
              : file
                ? 'PTLogo_btn_edit'
                : 'PTLogo_btn_download',
            'c/tests/placement-test/create-widget',
          )}
        />
      </div>
    </div>
  )
}

export default PTLogo
